<template>
    <div class="confirm-email-component-container">
        <div class="component-wrapper">
            <LoginHeader/>
            
            <div class="confirm-email-page-container">
                <div class="confirm-email-page-content-container">
                    <div class="confirm-email-container">
                        <section v-if="$store.confirmingAccount" class="confirming-account-section">
                            <div class="confirming-account-container">

                                <div v-if="confirmingEmailProgress" class="confirming-account-progress-container">
                                    <div class="confirming-account-msg-container">
                                        <p>{{ $t('email_being_confirmed') }}</p>
                                    </div>
                                    <div class="loading-spinner-container">
                                        <div class="spinner">
                                            <img src="../../assets/imgs/loading_spinner.png" alt="Spinner Image">
                                        </div>
                                    </div>
                                </div>

                                <div v-if="confirmingEmailSuccess" class="confirming-account-success-container">
                                    <div class="confirming-email-success-msg-container">
                                        <p>
                                            <span v-if="!alreadyConfirmed">{{ $t('account_activated_success') }}</span>
                                            <span v-else>{{ $t('account_already_activated') }}</span>
                                            <br><br>
                                            {{ $t('you_can_now_log_in') }}
                                        </p>
                                    </div>
                                    <div class="login-btn-container">
                                        <p>{{ $t('account_activated') }}</p>
                                        <div class="login-btn" @click="goToLoginPage">{{ $t('login') }}</div>
                                    </div>
                                </div>

                                <div v-if="confirmingEmailFailed" class="confirming-account-failed-container">
                                    <div class="confirming-email-failed-msg-container">
                                        <p>
                                            {{ $t('email_verification_failed') }}
                                            <br><br>
                                            {{ $t('try_again') }}
                                        </p>
                                    </div>
                                    <div class="reconfirm-account-container">
                                        <div class="reconfirm-account-msg-container">
                                            <p>
                                                {{ $t('not_successful_yet') }}
                                            </p>
                                        </div>
                                        <div class="send-confirm-mail-btn-section">
                                            <div class="send-confirm-mail-btn-container">
                                                <div v-if="!sendConfirmMailLoading" class="send-confirm-mail-btn"
                                                    @click="resendConfirmationEmail">
                                                    {{ $t('send_confirmation_email') }}
                                                </div>
                                                <div v-else class="loading-spinner-container">
                                                    <div class="spinner">
                                                        <img src="../../assets/imgs/loading_spinner.png" alt="Spinner Image">
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="sendConfirmMailFailed" class="error-msg-container">
                                                <p class="red">{{ sendConfirmMailErrMsg !== '' ? $t(`${sendConfirmMailErrMsg}`) :
                                                    (confirmingErrMsg !== '' ? $t(`${confirmingErrMsg}`) : '') }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="sendConfirmMailsuccess" class="resend-confirm-email-success-container">
                                    <div class="resend-confirm-email-success-msg-container">
                                        <p>
                                            {{ $t('confirmation_email_sent') }}
                                            <br><br>
                                            {{ $t('activate_account_via_confirmation_email') }}
                                        </p>
                                    </div>
                                    <div class="login-btn-container">
                                        <p>{{ $t('account_activated') }}</p>
                                        <div class="login-btn" @click="goToLoginPage">{{ $t('login') }}</div>
                                    </div>
                                </div>

                            </div>
                        </section>

                        <section v-if="$store.registrationCompleted" class="successful-registration-section">
                            <div class="registration-completed-container">
                                <div class="registration-completed-msg-container">
                                    <p>{{ $t('registration_successful') }}</p>
                                    <br>
                                    <p v-if="!$store.registerViaInvitationLink">{{ $t('activate_account_via_confirmation_email') }}</p>
                                    <br>
                                    <p v-if="$store.registerViaInvitationLink">{{ $t('you_can_now_log_in') }}</p>
                                </div>
                                <div class="login-btn-container">
                                    <p>{{ $t('account_activated') }}</p>
                                    <div class="login-btn" @click="goToLoginPage">{{ $t('login') }}</div>
                                </div>
                            </div>
                        </section>

                        <section v-if="$store.unconfirmedAccount" class="unconfirmed-account-section">
                            <div class="nconfirmed-account-warning-container">
                                <div class="unconfirmed-account-msg-container">
                                    <p>{{ $t('account_not_confirmed') }}</p>
                                    <p>{{ $t('activate_account_via_confirmation_email') }}</p>
                                </div>
                                <div class="reconfirm-account-container">
                                    <div class="reconfirm-account-msg-container">
                                        <p>{{ $t('confirmation_email_not_received') }}</p>
                                    </div>
                                    <div class="send-confirm-mail-btn-section">
                                        <div class="send-confirm-mail-btn-container">
                                            <div v-if="!sendConfirmMailLoading" class="send-confirm-mail-btn"
                                                @click="resendConfirmationEmail">
                                                {{ $t('send_confirmation_email') }}
                                            </div>
                                            <div v-else class="loading-spinner-container">
                                                <div class="spinner">
                                                    <img src="../../assets/imgs/loading_spinner.png" alt="Spinner Image">
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="sendConfirmMailFailed" class="error-msg-container">
                                            <p class="red">{{ $t(`${sendConfirmMailErrMsg}`) }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>

            <LoginFooter />
        </div>
    </div>
</template>

<script>
import LoginHeader from './LoginHeader.vue';
import LoginFooter from './LoginFooter.vue';
export default {
    name: 'ConfirmEmailPage',
    components: {
        LoginHeader,
        LoginFooter,
    },
    props: {
    },
    data() {
        return {
            alreadyConfirmed: false,
            confirmingEmailProgress: true,
            confirmingEmailSuccess: false,
            confirmingEmailFailed: false,
            confirmingErrMsg: '',
            sendConfirmMailLoading: false,
            sendConfirmMailFailed: false,
            sendConfirmMailsuccess: false,
            sendConfirmMailErrMsg: '',
        };
    },
    methods: {
        resetStates: function () {
            this.alreadyConfirmed = false;
            // this.confirmingEmailProgress = false;
            this.confirmingEmailSuccess = false;
            this.confirmingEmailFailed = false;
            this.confirmingErrMsg = '';
            this.sendConfirmMailLoading = false;
            this.sendConfirmMailFailed = false;
            this.sendConfirmMailsuccess = false;
            this.sendConfirmMailErrMsg = '';
        },
        goToLoginPage: function () {
            this.resetStates();
            this.$store.backToLoginPage();
        },
        resendConfirmationEmail: async function () {
            // console.log(this.$store.user.email);
            try {

                this.resetStates();
                this.sendConfirmMailLoading = true;

                const data = {
                    email: this.$store.user.email,
                    appLang: this.$store.selectedAppLanguage
                }

                const resendConfirmEmailResponse = await fetch('../../api/user/resendConfirmEmail', {
                    method: "POST",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json; charset=UTF-8',
                    },
                    body: JSON.stringify(data),
                });

                const resendConfirmEmailResponseJson = await resendConfirmEmailResponse.json();

                if (!resendConfirmEmailResponseJson.status) {
                    this.sendConfirmMailFailed = true;
                    this.sendConfirmMailErrMsg = resendConfirmEmailResponseJson.message;
                }
                else {
                    // console.log("resendConfirmEmailResponseJson.appLang: " + resendConfirmEmailResponseJson.appLang);
                    // Check if the account is already verified
                    if (resendConfirmEmailResponseJson.alreadyConfirmed) {
                        this.alreadyConfirmed = true;
                    }
                    else {
                        // Confirm email has resent successfully
                        this.$store.showFooterBackBtn = false;
                        this.$store.registrationCompleted = false;
                        this.$store.unconfirmedAccount = false;
                        this.confirmingEmailProgress = false;
                        this.confirmingEmailSuccess = false;
                        this.$store.confirmingAccount = true;
                        this.sendConfirmMailsuccess = true;
                    }
                    this.sendConfirmMailLoading = false;
                }
            }
            catch (err) {
                console.log(err);
                this.sendConfirmMailLoading = false;
                this.sendConfirmMailFailed = true;
                this.sendConfirmMailErrMsg = "something_went_wrong_try_again";
            }
        }
    },
    async created() {
        this.resetStates();

        // Check if the url has email and token to start the confirming proccess
        if (this.$route.params.email && this.$route.params.email != '' && this.$route.params.token && this.$route.params.token != '') {
            try {
                this.$store.user.email = this.$route.params.email;
                this.confirmingEmailProgress = true;

                const confirmData = {
                    email: this.$route.params.email,
                    token: this.$route.params.token,
                }
                const confirmingEmailResponse = await fetch('../../api/user/confirmEmail', {
                    method: "POST",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json; charset=UTF-8',
                    },
                    body: JSON.stringify(confirmData),
                });

                const confirmingEmailResponseJson = await confirmingEmailResponse.json();
                // console.log(confirmingEmailResponseJson);

                // this.$store.selectedAppLanguage = confirmingEmailResponseJson.appLang;

                if (!confirmingEmailResponseJson.status) {
                    this.confirmingEmailFailed = true;
                    this.confirmingErrMsg = confirmingEmailResponseJson.message;
                }
                else {
                    if (confirmingEmailResponseJson.alreadyConfirmed) {
                        this.alreadyConfirmed = true;
                    }
                    this.confirmingEmailSuccess = true;
                }
                this.confirmingEmailProgress = false;
                // http://localhost:8080/confirm/ahmadjiblawi@fit20.com/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ImFobWFkamlibGF3aUBmaXQyMC5jb20iLCJpYXQiOjE3MzQzNDM3ODQsImV4cCI6MTczNDQzMDE4NH0.3ZCcNnc8bn2SaQk9CTk7uYTd9HbU03GreDJ6d-4jHLc
            }
            catch (err) {
                console.log('Confirmation failed. Something went wrong!');
                this.confirmingEmailProgress = false;
                this.confirmingEmailFailed = true;
                this.confirmingErrMsg = 'something_went_wrong_try_again';
            }
        }
    }
};
</script>

<style>
.confirm-email-component-container {
    position: relative;
    height: 100vh;
    width: 100%;
}

.confirm-email-component-container .component-wrapper {
    height: 100vh;
    display: flex;
    flex-direction: column;
}

.confirm-email-component-container .confirm-email-page-container {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.confirm-email-component-container .confirm-email-page-content-container {
    width: 88%;
    max-width: 500px;
    height: 100%;
}

.confirm-email-component-container .confirm-email-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    /* border: 1px solid; */
}

.confirm-email-component-container .confirming-account-section {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: calc(11%) 0 15px;
}

.confirm-email-component-container .confirming-account-msg-container,
.confirm-email-component-container .confirming-account-success-container,
.confirm-email-component-container .confirming-account-failed-container,
.confirm-email-component-container .resend-confirm-email-success-msg-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.confirm-email-component-container .confirming-account-msg-container p,
.confirm-email-component-container .confirming-email-success-msg-container p,
.confirm-email-component-container .confirming-email-failed-msg-container p,
.confirm-email-component-container .resend-confirm-email-success-msg-container p {
    font-size: 30px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #a0a1a3;
    text-align: center;
    line-height: 35px;
    padding-bottom: 50px;
}

.confirm-email-component-container .loading-spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.confirm-email-component-container .registration-completed-container {
    flex: 1;
    width: 100%;
    max-width: 450px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 25px;
    /* border: 1px solid red; */
}

.confirm-email-component-container .registration-completed-msg-container {
    flex: 2;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 25px;
    /* border: 1px solid; */
}

.confirm-email-component-container .registration-completed-msg-container p {
    font-size: 30px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #a0a1a3;
    text-align: center;
    line-height: 35px;
}

.confirm-email-component-container .login-btn-container {
    flex: 1.5;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Open Sans Std', sans-serif;
}

.confirm-email-component-container .login-btn-container p {
    color: #616365;
    padding: 5px 0;
}

.confirm-email-component-container .login-btn {
    width: 50%;
    min-width: 200px;
    color: #fff;
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: 28px;
    text-align: center;
    letter-spacing: 1px;
    padding: 6px 0 10px;
    background: #009df4;
    border: 1px solid #fff;
    border-radius: 30px;
    cursor: pointer;
}

[dir="rtl"] .confirm-email-component-container .login-btn {
    width: max-content;
    font-size: min(26px, calc(14px + 2vw));
    padding: 4px 50px;
}

.confirm-email-component-container .unconfirmed-account-section {
    flex: 1;
    width: 100%;
    max-width: 500px;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    /* border: 1px solid; */
}

.confirm-email-component-container .nconfirmed-account-warning-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.confirm-email-component-container .unconfirmed-account-msg-container {
    padding: calc(11%) 0 15px;
}

.confirm-email-component-container .unconfirmed-account-msg-container p {
    font-size: 30px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #a0a1a3;
    text-align: center;
    padding: 10px 0;
    line-height: 35px;
}

.confirm-email-component-container .reconfirm-account-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.confirm-email-component-container .reconfirm-account-msg-container p {
    color: #616365;
    font-family: 'Open Sans Std', sans-serif;
}

.confirm-email-component-container .send-confirm-mail-btn-section {
    height: 85px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.confirm-email-component-container .send-confirm-mail-btn-container {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
}

.confirm-email-component-container .send-confirm-mail-btn {
    font-size: 30px;
    font-family: 'VAG Rounded Std', sans-serif;
    text-align: center;
    padding: 10px 25px;
    color: #ffffff;
    background: #92d400;
    border-radius: 30px;
    cursor: pointer;
}

[dir="rtl"] .confirm-email-component-container .send-confirm-mail-btn {
    font-size: min(26px, calc(14px + 2vw));
    padding: 4px 50px;
    max-height: 45px;
}

.confirm-email-component-container .unconfirmed-account-section .error-msg-container p {
    font-size: 12px;
    font-family: 'Open Sans Std', sans-serif;
}

@media (max-width: 475px) {
    .confirm-email-component-container .login-btn {
        font-size: 24px;
        min-width: 150px;
    }

    .confirm-email-component-container .unconfirmed-account-msg-container {
        width: 90%;
    }

    .confirm-email-component-container .registration-completed-msg-container p,
    .confirm-email-component-container .unconfirmed-account-msg-container p {
        font-size: calc(16px + 2vw);
    }
}

@media (max-width: 425px) {

    .confirm-email-component-container .confirming-account-msg-container p,
    .confirm-email-component-container .confirming-account-success-container p,
    .confirm-email-component-container .confirming-account-failed-container p,
    .confirm-email-component-container .resend-confirm-email-success-msg-container p {
        font-size: calc(14px + 2.8vw);
        max-width: 350px;
    }

    .confirm-email-component-container .confirming-account-msg-container p {
        padding-bottom: 25px;
    }

    .confirm-email-component-container .login-btn {
        font-size: 24px;
    }

    .confirm-email-component-container .login-btn-container p,
    .confirm-email-component-container .reconfirm-account-msg-container p {
        font-size: 14px;
    }

    .confirm-email-component-container .send-confirm-mail-btn {
        font-size: 22px;
    }
}

@media (max-width: 320px) {
    .confirm-email-component-container .registration-completed-msg-container p {
        font-size: calc(16px + 1.2vw);
    }

    .confirm-email-component-container .login-btn-container p,
    .confirm-email-component-container .reconfirm-account-msg-container p {
        font-size: 14px;
    }

    .confirm-email-component-container .send-confirm-mail-btn {
        font-size: calc(14px + 1.5vw);
    }
}
</style>